Date.prototype.addHours = function (h) {
  this.setTime(this.getTime() + (h * 60 * 60 * 1000));
  return this;
}
module.exports.StateList = [
  {id: "AA", display: "APO/FPO America"},
  {id: "AE", display: "APO / FPO Europe"},
  {id: "AP", display: "APO/FPO Pacific"},
  {id: "AL", display: "Alabama"},
  {id: "AK", display: "Alaska"},
  {id: "AZ", display: "Arizona"},
  {id: "AR", display: "Arkansas"},
  {id: "AS", display: "AmericanSamoa"},
  {id: "CA", display: "California"},
  {id: "CO", display: "Colorado"},
  {id: "CT", display: "Connecticut"},
  {id: "DE", display: "Delaware"},
  {id: "DC", display: "District Of Columbia"},
  {id: "FL", display: "Florida"},
  {id: "GA", display: "Georgia"},
  {id: "GU", display: "Guam"},
  {id: "HI", display: "Hawaii"},
  {id: "ID", display: "Idaho"},
  {id: "IL", display: "Illinois"},
  {id: "IN", display: "Indiana"},
  {id: "IA", display: "Iowa"},
  {id: "KS", display: "Kansas"},
  {id: "KY", display: "Kentucky"},
  {id: "LA", display: "Louisiana"},
  {id: "ME", display: "Maine"},
  {id: "MD", display: "Maryland"},
  {id: "MA", display: "Massachusetts"},
  {id: "MI", display: "Michigan"},
  {id: "MN", display: "Minnesota"},
  {id: "MS", display: "Mississippi"},
  {id: "MO", display: "Missouri"},
  {id: "MT", display: "Montana"},
  {id: "NE", display: "Nebraska"},
  {id: "NV", display: "Nevada"},
  {id: "NH", display: "New Hampshire"},
  {id: "NJ", display: "New Jersey"},
  {id: "NM", display: "New Mexico"},
  {id: "NY", display: "New York"},
  {id: "NC", display: "North Carolina"},
  {id: "ND", display: "North Dakota"},
  {id: "OH", display: "Ohio"},
  {id: "OK", display: "Oklahoma"},
  {id: "OR", display: "Oregon"},
  {id: "PA", display: "Pennsylvania"},
  {id: "PR", display: "Puerto Rico"},
  {id: "RI", display: "Rhode Island"},
  {id: "SC", display: "South Carolina"},
  {id: "SD", display: "South Dakota"},
  {id: "TN", display: "Tennessee"},
  {id: "TX", display: "Texas"},
  {id: "UT", display: "Utah"},
  {id: "VT", display: "Vermont"},
  {id: "VA", display: "Virginia"},
  {id: "VI", display: "Virgin Islands"},
  {id: "WA", display: "Washington"},
  {id: "WV", display: "West Virginia"}
];
module.exports.AvailableApps = [
  {value: "MBA", label: "MBA"}
];
module.exports.DeclinedReasons = [
  {value: "declined", label: "Declined"},
  {value: "postponed", label: "Postponed"},
  {value: "withdrawn", label: "Withdrawn"},
  {value: "rated", label: "Rated"},
  {value: "modified", label: "Modified"},
  {value: "issuedOther", label: "issued other than as applied for"},
];
module.exports.MBACoverageAmounts = [
  {value: "50000", label: "$50,000"},
  {value: "100000", label: "$100,000"},
  {value: "150000", label: "$150,000"},
  {value: "200000", label: "$200,000"},
  {value: "250000", label: "$250,000"},
  {value: "300000", label: "$300,000"},
  {value: "350000", label: "$350,000"},
  {value: "400000", label: "$400,000"},
  {value: "450000", label: "$450,000"},
  {value: "500000", label: "$500,000"},
  {value: "550000", label: "$550,000"},
  {value: "600000", label: "$600,000"},
  {value: "650000", label: "$650,000"},
  {value: "700000", label: "$700,000"},
  {value: "750000", label: "$750,000"},
  {value: "800000", label: "$800,000"},
  {value: "850000", label: "$850,000"},
  {value: "900000", label: "$900,000"},
  {value: "950000", label: "$950,000"},
  {value: "1000000", label: "$1,000,000"}
];
module.exports.MBACoverageTable = [
  {minValue: 0, maxValue: 29, unit: 50000, perUnitNT: 2.5, perUnitT: 5},
  {minValue: 30, maxValue: 34, unit: 50000, perUnitNT: 2.9, perUnitT: 5.8},
  {minValue: 35, maxValue: 39, unit: 50000, perUnitNT: 3.1, perUnitT: 6.2},
  {minValue: 40, maxValue: 44, unit: 50000, perUnitNT: 4, perUnitT: 8},
  {minValue: 45, maxValue: 49, unit: 50000, perUnitNT: 5, perUnitT: 10},
  {minValue: 50, maxValue: 54, unit: 50000, perUnitNT: 8.5, perUnitT: 17},
  {minValue: 55, maxValue: 59, unit: 50000, perUnitNT: 15.5, perUnitT: 31},
  {minValue: 60, maxValue: 64, unit: 50000, perUnitNT: 23.79, perUnitT: 47.58},
  {minValue: 65, maxValue: 69, unit: 50000, perUnitNT: 45.78, perUnitT: 91.56}
];
module.exports.getMBAPremium = function (age, useTobacco, coverageAmount) {
  if (age !== null && useTobacco !== null && coverageAmount !== null) {
    if (age < 0 || age >= 70) {
      return 0;
    }
    if (coverageAmount.length === 0) {
      return 0;
    }
    let amount = 0;
    try {
      amount = Number(coverageAmount);
    } catch (e) {
      amount = 0;
    }
    if (amount === 0) return 0;
    let table = module.exports.MBACoverageTable;
    if (!table) return 0;
    for (let a = 0; a < table.length; a++) {
      if (age >= table[a].minValue && age <= table[a].maxValue) {
        let perUnit = (useTobacco === true ? table[a].perUnitT : table[a].perUnitNT);
        return Math.round(amount / table[a].unit) * perUnit;
      }
    }
    return 0;
  }
  return 0;
}
module.exports.rankList = function (branch) {
  let rankArray = [];
  switch (branch) {
    case "2":
      rankArray.push("PVT", "PV2", "PFC", "SPC", "CPL", "SGT", "SSG", "SFC", "MSG", "1SG", "SGM", "CSM", "WO1", "CW2", "CW3", "CW4", "CW5", "2LT", "1LT", "CPT", "MAJ", "LTC", "COL", "BG", "MG", "LTG", "GEN", "MR", "MRS", "MS", "DR");
      break;
    case "5":
      rankArray.push("SR", "SA", "SN", "FR", "FA", "FN", "AR", "AA", "AN", "CR", "CA", "CN", "PO3", "PO2", "PO1", "CPO", "SCPO", "MCPO", "WO", "CWO2", "CWO3", "CWO4", "CWO5", "ENS", "LTJG", "LT", "LCDR", "CDR", "CAPT", "RDML", "RADM", "VADM", "ADM", "MR", "MRS", "MS", "DR");
      break;
    case "6":
      rankArray.push("AB", "AMN", "A1C", "SRA", "SSGT", "TSGT", "MSGT", "SMSGT", "CMSGT", "2LT", "1LT", "CAPT", "MAJ", "LTCOL", "COL", "BRIGGEN", "MAJGEN", "LTGEN", "GEN", "MR", "MRS", "MS", "DR");
      break;
    case "4":
      rankArray.push("PVT", "PFC", "LCPL", "CPL", "SGT", "SSGT", "GYSGT", "1STSGT", "MSGT", "MGYSGT", "SGTMAJ", "WO", "CWO2", "CWO3", "CWO4", "CWO5", "2NDLT", "1STLT", "CAPT", "MAJ", "LTCOL", "COL", "BGEN", "MAJGEN", "LTGEN", "GEN", "MR", "MRS", "MS", "DR");
      break;
    case "3":
      rankArray.push("SN", "PO3", "PO2", "PO1", "CPO", "SCPO", "MCPO", "CMC", "WO1", "CWO2", "CWO3", "CWO4", "ENS", "LTJG", "LT", "LCDR", "CDR", "CAPT", "RDML", "RADM", "VADM", "ADM", "MR ", "MRS ", "MS ", "DR");
      break;
    default:
      return null;
      break;
  }
  return rankArray;
};
module.exports.traversePropertiesString = function (baseObject, arrProps = []) {
  if (arrProps.length === 0) return "";
  let tObj = baseObject;
  for (let a = 0; a < arrProps.length; a++) {
    if (!tObj.hasOwnProperty(arrProps[a])) return "";
    tObj = tObj[arrProps[a]];
  }
  return tObj;
};
module.exports.traversePropertiesArray = function (baseObject, arrProps = []) {
  if (arrProps.length === 0) return [];
  let tObj = baseObject;
  for (let a = 0; a < arrProps.length; a++) {
    if (!tObj.hasOwnProperty(arrProps[a])) return [];
    tObj = tObj[arrProps[a]];
  }
  return tObj;
};
module.exports.getFormFieldValue = function (val) {
  if (val != null) {
    return val;
  } else {
    return "";
  }
};
module.exports.setFormFieldValue = function (field, value, values, readonly, cb) {
  if (readonly) return;
  let objPost;
  if (typeof (field) === "object") {
    objPost = {
      ...values,
      ...field
    };
  } else {
    objPost = {
      ...values,
      [field]: value,
    };
  }
  cb(objPost);
};
module.exports.setIndexFormFieldValue = function (valuesKey, index, field, value, values, readonly, cb) {
  if (readonly) return;
  let objPost = {...values};
  if (typeof (field) === "object") {
    objPost[valuesKey][index] = {
      ...objPost[valuesKey][index],
      ...field
    }
  } else {
    objPost[valuesKey][index] = {
      ...objPost[valuesKey][index],
      [field]: value
    }
  }
  cb(objPost);
};
module.exports.createString = function (obj, key, value, req = false, defaulted = null) {
  if (req && (typeof value === "undefined" || value === null)) return false;
  if ((typeof value === "undefined" || value === null)) value = defaulted;
  if (req && module.exports.getFormFieldValue(value).length === 0) return false;
  if (!obj.hasOwnProperty(key)) {
    obj[key] = value;
  }
  return true;
};
module.exports.createBoolean = function (obj, key, value, req = false, defaulted = null) {
  if (req && (typeof value === "undefined" || value === null)) return false;
  if ((typeof value === "undefined" || value === null)) value = defaulted;
  if (!obj.hasOwnProperty(key)) {
    obj[key] = value;
  }
  return true;
};
module.exports.createObject = function (obj, key, value) {
  if (!obj.hasOwnProperty(key)) {
    obj[key] = value;
  }
  return true;
};
module.exports.valueIf = function (bool, val, otherVal) {
  if (bool) {
    return val;
  } else {
    return otherVal;
  }
};
module.exports.zPad = function (str, digits = 1, cutoff = false) {
  if (digits < 1) {
    return str;
  } else {
    if (str.length === digits) {
      return str;
    } else if (str.length > digits) {
      if (cutoff) {
        console.log("cutoff", str.substr(0 - digits));
        return str.substr(0 - digits);
      } else {
        return str;
      }
    } else {
      return module.exports.zPad("0" + str, digits);
    }
  }
};
module.exports.formatDate = function (str) {
  return str.substr(5, 2) + "/" + str.substr(8, 2) + "/" + str.substr(0, 4);
};
module.exports.dateHelper = function (date) {
  return date.getFullYear() + "-" + module.exports.zPad(String(date.getMonth() + 1), 2) + "-" + module.exports.zPad(String(date.getUTCDate()), 2);
}
module.exports.addDays = function (date, num) {
  date.addHours(num * 24);
  return date;
}
module.exports.formatMoney = function (amount, decimalCount = 2, decimal = ".", thousands = ",") {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
    const negativeSign = amount < 0 ? "-" : "";
    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;
    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    console.log(e)
  }
};
module.exports.calculateAge = function (birthday) { // birthday is a string
  if (birthday.replace("_", "").length < 10) return 0;
  try {
    let ageDifMs = Date.now() - Date.parse(birthday);
    let ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  } catch (e) {
    return 0;
  }
};
// module.exports.savePDF = function(blob){
//   // It is necessary to create a new blob object with mime-type explicitly set
//   // otherwise only Chrome works like it should
//   var newBlob = new Blob([blob], {type: "application/pdf"});
//
//   // IE doesn't allow using a blob object directly as link href
//   // instead it is necessary to use msSaveOrOpenBlob
//   if (window.navigator && window.navigator.msSaveOrOpenBlob) {
//     window.navigator.msSaveOrOpenBlob(newBlob);
//     return;
//   }
//
//   // For other browsers:
//   // Create a link pointing to the ObjectURL containing the blob.
//   const data = window.URL.createObjectURL(newBlob);
//   var link = document.createElement('a');
//   link.href = data;
//   link.download="file.pdf";
//   link.click();
//   setTimeout(function(){
//     // For Firefox it is necessary to delay revoking the ObjectURL
//     window.URL.revokeObjectURL(data);
//   }, 100);
// };
module.exports.savePDF = function (blob, fileName) {
  module.exports.saveFile(blob, "application/pdf", fileName || "file.pdf")
};
module.exports.saveCSV = function (blob, fileName) {
  module.exports.saveFile(blob, "text/csv", fileName || "report.csv")
};
module.exports.saveFile = function (blob, mimeType, fileName) {
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  var newBlob = new Blob([blob], {type: mimeType});

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(newBlob);
  var link = document.createElement('a');
  link.href = data;
  link.download = fileName;
  link.click();
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
};
module.exports.isValidNumber = function (val) {
  let validNumberRegex = /^(-?\d+\.\d+)$|^(-?\d+)$/;
  return validNumberRegex.test(String(val));
}
module.exports.formsValueUpdater = function (key, value, formData, context, cb = () => {
}) {
  module.exports.setFormFieldValue(key, value, formData, false, (data) => context.setState({formData: data}, () => cb(data)));
};
module.exports.formsUpdater = function (evt, formData, context, cb = () => {
}) {
  module.exports.setFormFieldValue(evt.target.id, evt.target.value, formData, false, (data) => context.setState({formData: data}, () => cb(data)));
};
module.exports.formsCheckboxUpdater = function (evt, formData, context, cb = () => {
}) {
  module.exports.setFormFieldValue(evt.target.id, evt.target.checked, formData, false, (data) => context.setState({formData: data}, () => cb(data)));
};
module.exports.formsDataUpdater = function (key, val, formData, context, cb = () => {
}) {
  module.exports.setFormFieldValue(key, val, formData, false, (data) => context.setState({formData: data}, () => cb(data)));
};
module.exports.formsMultiUpdater = function (obj, formData, context, cb = () => {
}) {
  module.exports.setFormFieldValue(obj, null, formData, false, (data) => context.setState({formData: data}, () => cb(data)));
};

module.exports.formsUpdaterIndex = function (valuesKey, index, evt, formData, context, cb = () => {
}) {
  module.exports.setIndexFormFieldValue(valuesKey, index, evt.target.id, evt.target.value, formData, false, (data) => context.setState({formData: data}, () => cb(data)));
};


// WEBPACK FOOTER //
// ./src/containers/Applications/shared/shared.js